import {
    ExpertChatConfiguration,
    defaultPartnerProductConfiguration,
} from '@soluto-private/mx-types';
import { Key, storage } from '@soluto-private/mx-context';
import { Provider, createProvider } from '@soluto-private/mx-config';

import { monitor } from '@soluto-private/mx-monitor';

export const getExpertChatConfiguration =
    async (): Promise<ExpertChatConfiguration> => {
        const provider = createProvider(Provider.OneServiceApi);
        const partner = storage.get(Key.Client);

        try {
            const config = await provider.getPartnerProductConfiguration(
                partner
            );
            return (
                config?.expertChat ??
                defaultPartnerProductConfiguration.expertChat
            );
        } catch (ex) {
            const error =
                ex instanceof Error ? ex : new Error('Something went wrong');
            monitor.error('Error fetching configuration', error, { partner });

            return defaultPartnerProductConfiguration.expertChat;
        }
    };
